import posthog from 'posthog-js'
import { getRegistrationPartner } from './partners'

// Register-landing funnel events, shared by SignupLanding (real views and CTA
// clicks) and EmailLeadRedirect (auto-fired on behalf of nickel.com email
// leads that skip the landing page). Both paths MUST stay byte-identical for
// view -> click -> submit funnels to remain comparable, so the event names,
// source derivation, and property shapes live only here. `prefilled` adds the
// marker that distinguishes auto-fired events from real ones.

function registrationViewSource(searchParams: URLSearchParams): string {
  const referralCode = searchParams.get('r')
  return referralCode ? 'referral' : searchParams.get('ref') || 'direct'
}

export function captureRegistrationView(
  searchParams: URLSearchParams,
  { prefilled = false }: { prefilled?: boolean } = {},
) {
  const referralCode = searchParams.get('r')?.toLowerCase()
  const partner = getRegistrationPartner(searchParams)
  posthog.capture('registration_view', {
    source: registrationViewSource(searchParams),
    ...(referralCode ? { referral_code: referralCode } : {}),
    ...(partner ? { partner: partner.id } : {}),
    ...(prefilled ? { prefilled_email: true } : {}),
  })
}

export function captureRegistrationClick({
  signupMethod,
  provider,
  prefilled = false,
}: {
  signupMethod: 'password' | 'sso'
  provider?: 'google' | 'quickbooks'
  prefilled?: boolean
}) {
  posthog.capture('registration_click', {
    signup_method: signupMethod,
    ...(provider ? { provider } : {}),
    ...(prefilled ? { prefilled_email: true } : {}),
  })
}
